angular.module 'zc.projects'

.controller 'DetailProjectCtrl', ($scope, $translate, Page, Project, Campaign, ClearanceItemSet, currentProject, visitorIdsForDM) ->
  Page.setBodyClass ''
  $translate('projects.controllers.detailController.detailCampaignSetting').then (translation) ->
    Page.setTitle translation

  $scope.project = currentProject
  $scope.visitorIdsForDM = visitorIdsForDM

  $scope.removeClearanceItemSet = (obj) ->
    return unless obj
    ClearanceItemSet.destroy(obj).then ->
      $scope.project.clearance_item_sets = (set for set in $scope.project.clearance_item_sets when set.id isnt obj.id)

  $scope.getClearanceCampaigns = (set) ->
    return unless set
    Campaign.all
      projectId: $scope.project.id
      clearance_item_set_id: set.id
    .then (campaigns) ->
      set.clearanceCampaigns = campaigns



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects/controllers/detail_controller.js.coffee